import type { SessionPhase } from './marketHours'
import { resolveMarketableLimitPrice } from './limitPrice'

export interface EquityOrderPlan {
  mode: 'MARKET' | 'LIMIT'
  limitPrice?: number
  extendedHours: boolean
}

/**
 * Session-determined equity order routing (see CONTEXT.md):
 *   RTH / CLOSED -> MARKET DAY (CLOSED queues at the broker for next open)
 *   PRE / POST   -> Marketable Limit, extended-hours flag set
 * Returns null when an extended-hours order has no usable price — the caller
 * must block submission.
 */
export function planEquityOrder(args: {
  phase: SessionPhase
  side: 'BUY' | 'SELL'
  bid?: number | string | null
  ask?: number | string | null
  last?: number | string | null
}): EquityOrderPlan | null {
  const extended = args.phase === 'PRE' || args.phase === 'POST'
  if (!extended) return { mode: 'MARKET', extendedHours: false }
  const limitPrice = resolveMarketableLimitPrice(args)
  if (limitPrice == null) return null
  return { mode: 'LIMIT', limitPrice, extendedHours: true }
}

/** Extended-hours sizing: dollars -> whole shares (brokers reject fractional/notional). */
export function wholeSharesForDollars(dollars: number, price: number): number {
  if (!(dollars > 0) || !(price > 0)) return 0
  return Math.floor(dollars / price)
}
